export const API_EXTERNAL_ENDPOINT = 'search/suggest'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/search/suggest'
